const importExport = {

	init() {

		// Download export button functie die op basis van daterange een download url maakt
		$('#buttonDownloadExport').click(function() {
			var url = $(this).data('url');
			url = url + '/' + $('#begindatum').val() + '/' + $('#einddatum').val() + '/';
			window.location.href = url;
		});

		// Zet on change uit te voeren wijziging in de tabel
		$('select.werknemer-select').change(function() {
			var werknemer_id = $(this).val();
			$(this).closest('tr').find('td.werknemer-diff').html('Geen');
			$(this).closest('tr').find('td.adres-diff').html('Geen');
			if (werknemer_id != 'nieuw' && werknemer_id != 'overslaan') {
				var werknemerDiff = JSON.parse($(this).closest('tr').find('textarea').val());
				var tableClassColor = 'table-warning';
				var table = [];
				table.push('<th>Wijziging</th><th>Van</th><th>Naar</th>');
				$.each(werknemerDiff[werknemer_id]['werknemer'], function(key, value) {
					var classColor = '';
					if (key == 'achternaam' || key == 'voorletters' || key == 'geboorte_datum') {
						classColor = 'text-danger';
						tableClassColor = 'table-danger';
						$('.alert-naamswijziging').removeClass('d-none');
					}
					table.push('<tr class=' + classColor + '><td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
					// table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
				});
				if (table.length > 1) {
					// $(this).closest('tr').find('td.werknemer-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
					$(this).closest('tr').find('td.werknemer-diff').html('<table class="table table-striped ' + tableClassColor + ' mb-0">' + table.join('') + '</table>');
				}
				table = [];
				table.push('<th>Wijziging</th><th>Van</th><th>Naar</th>');
				$.each(werknemerDiff[werknemer_id]['adres'], function(key, value) {
					// table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td>');
					table.push('<tr><td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
				});
				if (table.length > 1) {
					// $(this).closest('tr').find('td.adres-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
					$(this).closest('tr').find('td.adres-diff').html('<table class="table table-striped">' + table.join('') + '</table>');
				}
			}
		});

		// Trigger een change event voor alle werknemer select elementen
		$('select.werknemer-select').each(function() {
			$(this).trigger('change');
		});

		// Toon import errors wanneer pagina geladen wordt
		$('.modal-import-errors').modal('show');

		// Maak tooltip aan met error toelichting voor alle rijen
		$('.modal-import-errors table tbody tr').each(function() {
			$('[data-toggle=tooltip]').tooltip();
		});

	}

};

export default importExport;
